import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "15px", textAlign: "center" }}>
          <h1>
            Something went wrong :(
            <br />
            Please Refresh.
          </h1>
          <h3>Details:</h3>
          <pre style={{ whiteSpace: "pre-wrap" }}>Error: {JSON.stringify(this.state.error)}</pre>
          <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(this.state.info)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
